<template>
    <el-container class="SearchXmxx">
        <el-main>
            <div class="headFirst"></div>
            <div class="headSecond">项目详细情况</div>
            <div class="mainCard" v-for="item in tableDataXmxx">
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    期现楼：
                                </span>
                            <span class="Spancontent2">
                                    {{item.QXL}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    坐落：
                                </span>
                            <span class="Spancontent2">
                                    {{item.ZL}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    项目名称：
                                </span>
                            <span class="Spancontent2">
                                    {{item.XMMC}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    总层数：
                                </span>
                            <span class="Spancontent2">
                                    {{item.ZCS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    楼栋序号：
                                </span>
                            <span class="Spancontent2">
                                    {{item.LDXH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    地上层数：
                                </span>
                            <span class="Spancontent2">
                                    {{item.DSCS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    区县：
                                </span>
                            <span class="Spancontent2">
                                    {{item.QX}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    地下层数：
                                </span>
                            <span class="Spancontent2">
                                    {{item.DXCS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    院门牌号：
                                </span>
                            <span class="Spancontent2">
                                    {{item.YMPH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    套数：
                                </span>
                            <span class="Spancontent2">
                                    {{item.TS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    幢号：
                                </span>
                            <span class="Spancontent2">
                                    {{item.ZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    楼盘表：
                                </span>
                            <span class="Spancontent2">
                                    <el-button plain class="lpbButton" @click="OpenLpbXx(item.BUILDID)">
                                                详细
                                    </el-button>
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
        </el-main>
    </el-container>
</template>

<script>
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'spf/';
    export default {
        name: "SearchXmxx",
        data() {
            return{
				xmmc: null,
                tableDataXmxx:[{}],
            }
        },
        methods: {
            OpenLpbXx(buildid){
                this.$router.push({path:'/ywhome/spfhome/lpbXx',query:{roomid:buildid}})
            },
        },
		created() {
			this.xmmc = this.$route.query.xmmc;
			axios.get(base_url + "xmxxxx" + "?xmmc=" + this.xmmc).then(response => this.tableDataXmxx = response.data).catch(error => console.log(error, "error"));
		}
    }
</script>

<style scoped>
    @import "../assets/css/spf/SearchXmxx.css";
</style>